import { ResponsiveRangePicker } from "@opendash/core/dist/components/ResponsiveRangePicker";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import React from "react";

type Props = {
  onChange?: (value: { start?: Date; end: Date }) => void;
  value?: {
    start?: Date;
    end: Date;
  };
};

export const DuedateRangePicker = observer((props: Props) => {
  return (
    <ResponsiveRangePicker
      allowEmpty={[true, false]}
      onChange={(dates) =>
        dates
          ? props.onChange?.({
              start: dates[0]?.toDate(),
              end: dates[1]?.toDate(),
            })
          : undefined
      }
      value={
        props.value
          ? [
              props.value?.start ? dayjs(props.value.start) : null,
              dayjs(props.value?.end),
            ]
          : undefined
      }
    />
  );
});
